import React from "react";
import { motion } from "framer-motion";
import logo from "./newcompanylogo.png";
const apps = [
  {
    name: "Can You Whisper?",
    tagline: "Sshsh...Keep it quiet. Play against family and friends. ",
    image: "canyouwhisper.png",
    description:
      "A simple and fun game for whispering words.",
    links: {
      ios: "https://apps.apple.com/pt/app/can-you-whisper/id6761400735",
    },
  },
  
  {
    name: "Account Ant",
    tagline: "Track expenses with clarity",
    image: "accountant.png",
    description:
      "A simple and intuitive way to manage daily expenses and gain financial awareness.",
    links: {
      ios: "https://apps.apple.com/us/app/account-ant-personal-money/id1367240695",
    },
  },
  {
    name: "NetGirl",
    tagline: "Utility tools in one place",
    image: "netgirlios.png",
    description:
      "Discover wifi networks, bluetooth and mobile networks.",
    links: {
      ios: "https://apps.apple.com/us/app/netgirl/id1510251406",
      android: "https://play.google.com/store/apps/details?id=com.hadokoa.netgirl&pli=1",
    },
  },
   {
    name: "Apofasi",
    tagline: "Decide",
    image: "apofasi.png",
    description:
      "Help you decide. Design your decision. Select the best.",
    links: {
      ios: "https://itunes.apple.com/us/app/apofasi-decision-making-tool/id541689366?mt=8",
    },
  },
   {
    name: "ApergiaGR Free",
    tagline: "Plan your day",
    image: "apergiagrfree.png",
    description:
      "A free version of our famous Strikes and News in Greece app.",
    links: {
      ios: "https://itunes.apple.com/gr/app/apergiagr-free/id473550392?mt=8",
    },
  },
   {
    name: "ApergiaGR",
    tagline: "Plan your day",
    image: "apergiagr.png",
    description:
      "Our famous strikes/news/weather app. Top #1 News App in Greece.",
    links: {
      ios: "https://itunes.apple.com/gr/app/apergiagr-free/id473550392?mt=8",
    },
  },
];

const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0 },
};

const HadokoaLogoModern = () => (
  <svg
    width="220"
    height="90"
    viewBox="0 0 220 90"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="skewX(-6)">
      <text
        x="10"
        y="50"
        fontFamily="Inter, sans-serif"
        fontSize="40"
        fontWeight="900"
        fill="#00D1D1"
        letterSpacing="1.5"
      >
        HADOKOA
      </text>

      <line
        x1="10"
        y1="65"
        x2="190"
        y2="65"
        stroke="#00D1D1"
        strokeWidth="5"
        strokeLinecap="round"
      />
    </g>
  </svg>
);
export default function HomePage() {
  return (
    <div style={styles.container}>
      {/* HERO */}
      <motion.section
        style={styles.hero}
        initial="hidden"
        animate="show"
        variants={containerVariants}
      >
        <motion.section style={styles.hero}>
 <img
    src={logo}
    alt="Hadokoa logo"
    style={{
      width: "220px",
      marginBottom: "15px",
    }}
  />

<h1 style={{ marginTop: "8px" }}>
    We build mobile apps that solve everyday problems
  </h1>

  <p style={styles.subtitle}>
    Independent developers crafting simple, useful tools used by real people.
  </p>
</motion.section>

        <motion.div variants={fadeUp} style={styles.ctaRow}>
          <button
  style={styles.primaryBtn}
  onClick={() => {
    document.getElementById("apps")?.scrollIntoView({
      behavior: "smooth",
    });
  }}
>
  Explore Apps
</button>
         
                <button style={styles.secondaryBtn}
  onClick={() => {
    const email = "info" + "@hadokoa.com";
    window.location.href = `mailto:${email}`;
  }}
>
  Contact
</button>

        </motion.div>
      </motion.section>

      {/* APPS */}
      <section id="apps" style={styles.section}>
        <h2 style={styles.sectionTitle}>Apps</h2>

        <motion.div
          style={styles.grid}
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          {apps.map((app, i) => (
            <motion.div
              key={i}
              variants={fadeUp}
              whileHover={{ scale: 1.03 }}
              style={styles.card}
            >
              <img src={app.image} alt={app.name} style={styles.image} />

              <h3 style={styles.appTitle}>{app.name}</h3>
              <p style={styles.tagline}>{app.tagline}</p>

              <p style={styles.description}>{app.description}</p>

              <div style={styles.links}>
               {app.links.ios && (
    <a
      href={app.links.ios}
      target="_blank"
      rel="noopener noreferrer"
      style={{ ...styles.storeBtn, ...styles.iosBtn }}
    >
      <img src="applestore.png"/>
    </a>
  )}

  {app.links.android && (
    <a
      href={app.links.android}
      target="_blank"
      rel="noopener noreferrer"
      style={{ ...styles.storeBtn, ...styles.androidBtn }}
    >
      <img src="googleplay.png"/>
    </a>
  )}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </section>

      {/* ABOUT */}
      <motion.section
        style={styles.about}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        <h2>About Hadokoa</h2>
        <p>
          We focus on building small, practical apps that solve real-world
          problems. Our approach is simple: useful features, clean design, and
          fast performance.
        </p>
      </motion.section>

      {/* CTA */}
      <motion.section
        style={styles.cta}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
      >
        <h2>Want to collaborate?</h2>
        
        <button style={styles.primaryBtn}
  onClick={() => {
    const email = "info" + "@hadokoa.com";
    window.location.href = `mailto:${email}`;
  }}
>
  Get in touch
</button>

      </motion.section>

      {/* FOOTER */}
      <footer style={styles.footer}>
        <p>© {new Date().getFullYear()} Hadokoa</p>
      </footer>
    </div>
  );
}

const styles = {
  container: {
    fontFamily: "system-ui, sans-serif",
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "20px",
     background: "linear-gradient(to bottom, #f9fefe, #ffffff)",
  },

  hero: {
    textAlign: "center",
    padding: "100px 0 80px",
  },
  title: {
    fontSize: "2.8rem",
    fontWeight: "700",
  },
  subtitle: {
    marginTop: "15px",
    color: "#555",
    maxWidth: "600px",
    marginInline: "auto",
    fontSize: "1.1rem",
  },


  ctaRow: {
    marginTop: "25px",
    display: "flex",
    justifyContent: "center",
    gap: "12px",
  },
  primaryBtn: {
    padding: "12px 24px",
    background: "#000",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    borderRadius: "6px",
  },
  secondaryBtn: {
    padding: "12px 24px",
    border: "1px solid #000",
    background: "transparent",
    cursor: "pointer",
    borderRadius: "6px",
  },
  section: {
    marginTop: "60px",
  },
  sectionTitle: {
    fontSize: "2rem",
    marginBottom: "30px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "30px",
  },
  card: {
    border: "1px solid #eee",
    borderRadius: "14px",
  background: "#fff",

  boxShadow: "0 5px 15px rgba(0, 209, 209, 0.12)",
    padding: "20px",
  
  },
  
  image: {
    width: "100%",
    borderRadius: "10px",
    marginBottom: "15px",
  },
  appTitle: {
    fontSize: "1.4rem",
    fontWeight: "600",
  },
 tagline: {
  fontSize: "1.05rem",
  fontWeight: "600",
  color: "#222",
  marginBottom: "6px",
},

description: {
  fontSize: "0.9rem",
  color: "#666",
  lineHeight: "1.6",
},
  links: {
    marginTop: "15px",
    display: "flex",
    gap: "15px",
  },
  about: {
    marginTop: "100px",
    textAlign: "center",
  },
  cta: {
    marginTop: "100px",
    textAlign: "center",
  },
  footer: {
    marginTop: "80px",
    textAlign: "center",
    color: "#777",
  },
};